import React from 'react'
import PanelHead from '../../UI/Panel/PanelHead';
import PanelBody from '../../UI/Panel/PanelBody';
import { AddBalanceRequestsTable } from '../../UI/AddBalanceRequests/AddBalanceRequestsTable';

const BalanceRequests = () => {
  return (
    <div>
      <PanelHead title="BalanceRequests" />
      <PanelBody content={<AddBalanceRequestsTable />} />
    </div>
  )
}

export default BalanceRequests;